import { render, staticRenderFns } from "./InvestmentAccountTypeSlots.vue?vue&type=template&id=e489d196&scoped=true"
import script from "./InvestmentAccountTypeSlots.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountTypeSlots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e489d196",
  null
  
)

export default component.exports